import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const HomePage = lazy(() => import('pages/homePage'));
const ViewRedemptionPage = lazy(() => import('pages/ViewRedemptionPage'));
const ShowcasePage = lazy(() => import('pages/ShowcasePage'));
const ListSolicitation = lazy(() => import('pages/listSolicitation/ListSolicitation'));
const NewSolicitation = lazy(() => import('pages/newSolicitation/NewSolicitation'));
const NewSolicitationSuccess = lazy(() => import('pages/newSolicitation/NewSolicitationSuccess'));
const LikePlusPage = lazy(() => import('pages/likePlusPage'));
const ViewRedemptionAprovePage = lazy(() => import('pages/ViewRedemptionAprove/ViewRedemptionAprovePage'));
const RedemptionsReportPage = lazy(() => import('pages/RedemptionsReportPage'));
const ApproveHierarchy = lazy(() => import('pages/ApproveHierarchy/ApproveHierarchy'));
const SolicitationPage = lazy(() => import('pages/SolicitationPage'));
const ApproveQuote = lazy(() => import('pages/approveQuotePage/ApproveQuote'));
const PixPage = lazy(() => import('pages/PixPage'));
const PopBallonPage = lazy(() => import('pages/popBallonPage'));
const ManageConciergeSolicitationPage = lazy(() => import('pages/ManageConciergeSolicitationPage'));
const ListConciergePage = lazy(() => import('pages/ListConciergePage'));
const ProfilePage = lazy(() => import('pages/profilePage'));
const CartPage = lazy(() => import('pages/cartPage'));
const OrdersPage = lazy(() => import('pages/ordersPage'));
const MyOrdersGiftPage = lazy(() => import('pages/ordersGiftPage'));
const OrderDetailsPage = lazy(() => import('pages/orderDetailsPage'));
const ExtractPage = lazy(() => import('pages/ExtractPage'));
const StoreListPage = lazy(() => import('pages/StorePage'));
const VoucherPage = lazy(() => import('pages/VoucherPage/VoucherPage'));
const CategoryPage = lazy(() => import('pages/CategoryPage/CategoryPage'));
const CheckoutPage = lazy(() => import('pages/checkoutPage'));
const ProductPage = lazy(() => import('pages/productPage'));
const AboutPage = lazy(() => import('pages/aboutPage'));
const WishlistPage = lazy(() => import('pages/wishlistPage'));
const NewConciergeSolicitationPage = lazy(() =>
  import('pages/NewConciergeSolicitationPage')
);
const StoresSearchPage = lazy(() =>
  import('pages/StoresSearchPage/StoresSearchPage')
);
const SearchPage = lazy(() => import('pages/SearchPage'));
const PhoneRecharge = lazy(() => import('pages/phoneRechargePage'));
const FuelCreditPage = lazy(() => import('pages/fuelCreditPage'));
const BillPaymentPage = lazy(() => import('pages/BillPaymentPage'));
const ContactPage = lazy(() => import('pages/ContactPage'));
const GiftPage = lazy(() => import('pages/giftPage'));
const SecurityPage = lazy(() => import('pages/SecurityPage'));
const Callback = lazy(() => import('Shared/Auth/Pages/Callback'));
const Logout = lazy(() => import('Shared/Auth/Pages/Logout'));
const AuthGuard = lazy(() => import('Shared/Auth/AuthGuard/AuthGuard'));
const CategoryPagePlaceholder = lazy(() => import('../pages/CategoryPage/CategoryPagePlaceholder'));
const HomepagePlaceholder = lazy(() => import('../pages/homePage/HomepagePlaceholder'));
const Showcase = lazy(() => import('../pages/Showcase'));
const SpotEditRedemption = lazy(() => import('pages/SpotEditRedemption/SpotEditRedemption'));
const Redirect = lazy(() => import('Shared/Auth/Pages/Callback'));
const LikePlusOnlinePage = lazy(() =>
  import('pages/likePlusPageGeneric/Provider')
);
const RegulationPage = lazy(() => import('pages/regulationPage'));
const TermsPage = lazy(() => import('pages/termsPage'));
const PrivacyPage = lazy(() => import('pages/privacyPage'));
const FaqPage = lazy(() => import('pages/faqPage'));
const ConciergeSolicitationPageTemp = lazy(() =>
  import('pages/ConciergeSolicitationPage/ConciergeSolicitationPageTemp')
);
const ListManagePointsPage = lazy(() => import('pages/ListManagePointsPage'));
const ListHistoryDistributionPointsPage = lazy(() =>
  import('pages/ListHistoryDistributionPointsPage')
);
const ListDetailsDistributionPointsPage = lazy(() =>
  import('pages/ListDetailsDistributionPointsPage')
);
const FocalPointManagePointsPage = lazy(() =>
  import('pages/FocalPointManagePointsPage')
);

const Pdp = lazy(
  () => import('pages/productPage/refact')
);

const NotFoundPage = lazy(
  () => import('pages/notFoundPage')
);

const ChangePasswordPage = lazy(() => 
  import('pages/ChangePasswordPage')
);

import { HasConciergeService } from '../Constants/Concierge';
import { RootLoadingAnimation } from '../Services/Providers/RootLoading';

import ynToBool from '../Utils/ynToBool';

// APP ROUTER
const AppRouter = () => (
  <Suspense fallback={<RootLoadingAnimation />}>
    <Routes>
      <Route path="/auth">
        <Route path="callback" element={<Callback />} />
        <Route path="login" element={<Redirect to={'/'} />} />
        <Route path="logout" element={<Logout />} />
      </Route>
      <Route
        path="/category/:id/:pagenumber/filter/:filter"
        element={
          <AuthGuard
            loadingComponent={<CategoryPagePlaceholder />}
            element={<CategoryPage />}
          />
        }
      />
      <Route
        path="/category/:id/:pagenumber"
        element={
          <AuthGuard
            loadingComponent={<CategoryPagePlaceholder />}
            element={<CategoryPage />}
          />
        }
      />
      <Route
        path="/store/:id/:pagenumber"
        element={
          <AuthGuard
            loadingComponent={<CategoryPagePlaceholder />}
            element={<StoresSearchPage />}
          />
        }
      />
      <Route
        path="/showcase"
        element={
          <AuthGuard
            loadingComponent={<CategoryPagePlaceholder />}
            element={<Showcase />}
          />
        }
      />
      <Route
        path="/store/:id/:pagenumber/filter/:filter"
        element={
          <AuthGuard
            loadingComponent={<CategoryPagePlaceholder />}
            element={<StoresSearchPage />}
          />
        }
      />
      <Route
        path="/search/:pagenumber"
        element={
          <AuthGuard
            loadingComponent={<CategoryPagePlaceholder />}
            element={<SearchPage />}
          />
        }
      />
      <Route
        path="/search/:pagenumber/filter/:filter"
        element={
          <AuthGuard
            loadingComponent={<CategoryPagePlaceholder />}
            element={<SearchPage />}
          />
        }
      />

      <Route
        path="/"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<HomePage />}
          />
        }
      />
      <Route
        path="/home"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<HomePage />}
          />
        }
      />
      <Route
        path="/product/:sku"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<Pdp />}
          />
        }
      />
      <Route
        path="/cart"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<CartPage />}
          />
        }
      />
      <Route
        path="/checkout"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<CheckoutPage />}
          />
        }
      />
      <Route
        path="/categories"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<CategoryPage />}
          />
        }
      />
      <Route
        path="/vouchers"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<VoucherPage />}
          />
        }
      />
      <Route
        path="/stores"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<StoreListPage />}
          />
        }
      />
      <Route
        path="/wishlist"
        element={
          <AuthGuard
            loadingComponent={<CategoryPagePlaceholder />}
            element={<WishlistPage />}
          />
        }
      />
      <Route
        path="/extract"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<ExtractPage />}
          />
        }
      />
      <Route
        path="/my-orders"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<OrdersPage />}
          />
        }
      />
      <Route
        path="/order-details"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<OrderDetailsPage />}
          />
        }
      />

      <Route
        path="/profile"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<ProfilePage />}
          />
        }
      />

      <Route
        path="/account/password"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<ChangePasswordPage />}
          />
        }
      />

      <Route
        path="/view-redemption/:id"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<ViewRedemptionPage />}
          />
        }
      />
      <Route
        path="/about"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<AboutPage />}
          />
        }
      />
      <Route
        path="/showcase/:identifier"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<ShowcasePage />}
          />
        }
      />
      <Route
        path="/list-redemptions"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<ListSolicitation />}
          />
        }
      />
      <Route
        path="/redemptions-report"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<RedemptionsReportPage />}
          />
        }
      />
      <Route
        path="/spot-redemption"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<NewSolicitation />}
          />
        }
      />
      <Route
        path="/redemption-success"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<NewSolicitationSuccess />}
          />
        }
      />
      <Route
        path="/gift"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<GiftPage />}
          />
        }
      />
      <Route
        path="/approve-redemption/:id"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<ViewRedemptionAprovePage />}
          />
        }
      />
      <Route
        path="/approve-redemption-hierarchy/:id"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<ApproveHierarchy />}
          />
        }
      />

      <Route
        path="/edit-redemption/:id"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<SpotEditRedemption />}
          />
        }
      />

      <Route
        path="/like-plus"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={
              ynToBool(process.env.REACT_APP_LIKE_PLUS_HAS_CUSTOM_SERVICE) ? (
                <LikePlusPage />
              ) : (
                <LikePlusOnlinePage />
              )
            }
          />
        }
      />

      <Route
        path="/mobile-recharge"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<PhoneRecharge />}
          />
        }
      />
      <Route
        path="/campanhas"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<PopBallonPage />}
          />
        }
      />
      {(() => {
        if (!ynToBool(process.env.REACT_APP_SHOW_CAMPAIGN_MIGRATION_MENU))
          return null;
        return (
          <Route
            path="/solicitation"
            element={
              <AuthGuard
                loadingComponent={<HomepagePlaceholder />}
                element={<SolicitationPage />}
              />
            }
          />
        );
      })()}
      <Route
        path="/fuelcredit"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<FuelCreditPage />}
          />
        }
      />
      <Route
        path="/billpayment"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<BillPaymentPage />}
          />
        }
      />
      <Route
        path="/approve-redemption-quote/:id"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<ApproveQuote />}
          />
        }
      />

      <Route
        path="/regulation"
        element={
          <AuthGuard
            enablePublic={true}
            loadingComponent={<HomepagePlaceholder />}
            element={<RegulationPage />}
          />
        }
      />
      
      <Route
        path="/faq"
        element={
          <AuthGuard
            enablePublic={true}
            loadingComponent={<HomepagePlaceholder />}
            element={<FaqPage />}
          />
        }
      />


      <Route
        path="/terms"
        element={
          <AuthGuard
            enablePublic={true}
            loadingComponent={<HomepagePlaceholder />}
            element={<TermsPage />}
          />
        }
      />
      <Route
        path="/privacy"
        element={
          <AuthGuard
            enablePublic={true}
            loadingComponent={<HomepagePlaceholder />}
            element={<PrivacyPage />}
          />
        }
      />
      <Route
        path="/transferencia-bancaria"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<PixPage />}
          />
        }
      />
      <Route
        path="/contact"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<ContactPage />}
          />
        }
      />
      <Route
        path="/security"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<SecurityPage />}
          />
        }
      />

      <Route
        path="/new-concierge-solicitation"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<ConciergeSolicitationPageTemp />}
          />
        }
      />

      <Route
        path="/my-orders-gift"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<MyOrdersGiftPage />}
          />
        }
      />
   
      {ynToBool(HasConciergeService) && (
        <>
          <Route
            path="/list-solicitations"
            element={
              <AuthGuard
                loadingComponent={<HomepagePlaceholder />}
                element={<ListConciergePage />}
              />
            }
          />
          <Route
            path="/new-solicitation"
            element={
              <AuthGuard
                loadingComponent={<HomepagePlaceholder />}
                element={<NewConciergeSolicitationPage />}
              />
            }
          />

          <Route
            path="/new-solicitation/:solicitationId"
            element={
              <AuthGuard
                loadingComponent={<HomepagePlaceholder />}
                element={<NewConciergeSolicitationPage />}
              />
            }
          />

          <Route
            path="/manage-solicitation/:id"
            element={
              <AuthGuard
                loadingComponent={<HomepagePlaceholder />}
                element={<ManageConciergeSolicitationPage />}
              />
            }
          />
        </>
      )}


      {
        ynToBool(process.env.REACT_APP_FOCALPOINT_CAMPAIGN_HAS_FOCAL_POINT) &&
        <>
          <Route
            path="/focal-point-manage-points/:id"
            element={
              <AuthGuard
                loadingComponent={<HomepagePlaceholder />}
                element={<FocalPointManagePointsPage />}
              />
            }
          />

          <Route
            path="/list-manage-points"
            element={
              <AuthGuard
                loadingComponent={<HomepagePlaceholder />}
                element={<ListManagePointsPage />}
              />
            }
          />

          <Route
            path="/list-details-distribution-points/:id"
            element={
              <AuthGuard
                loadingComponent={<HomepagePlaceholder />}
                element={<ListDetailsDistributionPointsPage />}
              />
            }
          />

          <Route
            path="/list-history-distribution-points"
            element={
              <AuthGuard
                loadingComponent={<HomepagePlaceholder />}
                element={<ListHistoryDistributionPointsPage />}
              />
            }
          />
        </>

      }

      <Route
        path="/my-orders-gift"
        element={
          <AuthGuard
            loadingComponent={<HomepagePlaceholder />}
            element={<MyOrdersGiftPage />}
          />
        }
      />

      <Route 
        path="pdp/:sku"
        element={
          <AuthGuard 
            element={<Pdp />}
          />
        }
      />

      <Route 
        path="*"
        element={
          <AuthGuard 
            element={<NotFoundPage />}
          />
        }
      />
    </Routes>
  </Suspense>
);

export default AppRouter;
